import React, { useContext } from "react"
import { withRouter, Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { LangContext } from "../../LangProvider"

function DesktopMenus({ menus, location }) {
  const { t } = useTranslation()
  const { lang, dispatch } = useContext(LangContext)

  const handleChangeLanguage = event => {
    dispatch(event.target.value)
  }

  return (
    <div className="uk-navbar-right" id="desktop-menus">
      <ul className="uk-navbar-nav">
        {menus.map(menu => (
          <li key={menu.pathname}>
            <Link
              className={menu.pathname === location.pathname ? "font-red" : ""}
              to={menu.pathname}
            >
              {t("navbar." + menu.label)}
            </Link>
          </li>
        ))}
        <li>
          <div className="uk-height-1-1 uk-flex uk-flex-middle uk-text-small">
            <select
              data-placeholder="Choose a language"
              className="uk-select"
              value={lang}
              onChange={handleChangeLanguage}
            >
              <option value="en">EN</option>
              <option value="ind">ID</option>
            </select>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default withRouter(DesktopMenus)
